export default __webpack_public_path__ + "static/AdobeStock_241450546_80-93ae44ffce3610aa34a03bd272c65e9f.jpg";